import React, { useRef, useEffect } from 'react';

import { FormGroup } from 'design-system';
import { useTranslate } from 'gatsby-theme-soluble-source';

import style from './styles.module.scss';

export default function SearchFormComponent({ action }) {
    const translation = useTranslate();
    const termRef = useRef();

    useEffect(() => {
        if (termRef && termRef.current && typeof window !== 'undefined') {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            if (urlParams.get('term')) {
                termRef.current.setValue(urlParams.get('term'));
            }
        }
    }, [termRef]);

    return (
        <form action={action} method="GET" className={style.form}>
            <FormGroup
                ref={termRef}
                name="term"
                type="text"
                required={true}
                placeholder={translation['search.placeholder'].text}
                className={style.text}
            />
            <button type="submit" className={style.submit}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28">
                    <path
                        fill="#E4E6E8"
                        fillRule="evenodd"
                        d="M12.359 2.674L2.359 12.674 1.672 13.393 2.359 14.112 12.359 24.112 13.797 22.674 5.516 14.393 25.078 14.393 25.078 12.393 5.516 12.393 13.797 4.112z"
                        transform="matrix(-1 0 0 1 27.036 .286)"
                    />
                </svg>
            </button>
        </form>
    );
}
